import { render } from "./Salary.vue?vue&type=template&id=12b2289e&scoped=true"
import script from "./Salary.vue?vue&type=script&lang=js"
export * from "./Salary.vue?vue&type=script&lang=js"

import "./Salary.vue?vue&type=style&index=0&id=12b2289e&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b2289e"]])

export default __exports__